/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: smsProviderConstants.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the PBX SMS Messaging module.
────────────────────────────────────────────────────────────────*/


import { SelectOption } from '../../components/ui/select';
import { SmsProviderType } from './types';

export const PROVIDER_OPTIONS: SelectOption[] = [
    { value: 'twilio',          label: 'Twilio' },
    { value: 'telnyx',          label: 'Telnyx' },
    { value: 'signalwire',      label: 'SignalWire' },
    { value: 'vonage',          label: 'Vonage' },
    { value: 'bandwidth',       label: 'Bandwidth' },
    { value: 'plivo',           label: 'Plivo' },
    { value: 'bulkvs',          label: 'BulkVS' },
    { value: 'skyetel',         label: 'Skyetel' },
    { value: 'flowroute',       label: 'Flowroute' },
    { value: 'voipms',          label: 'VoIP.ms' },
    { value: 'didww',           label: 'DIDWW' },
    { value: 'commio',          label: 'Commio' },
    { value: 'voxtelesys',      label: 'Voxtelesys' },
    { value: 'questblue',       label: 'QuestBlue' },
    { value: 'wavix',           label: 'Wavix' },
    { value: 'voipinnovations', label: 'VoIP Innovations' },
    { value: 'wayinteractive',  label: 'Way Interactive' },
    { value: 'custom',          label: 'Custom Provider' },
];

export const PROVIDER_FIELDS: Record<SmsProviderType, { required: string[]; optional: string[] }> = {
    twilio:          { required: ['accountSid', 'apiKey'],                          optional: [] },
    telnyx:          { required: ['apiKey'],                                        optional: ['apiEndpoint'] },
    signalwire:      { required: ['accountSid', 'apiKey', 'apiEndpoint'],           optional: [] },
    vonage:          { required: ['apiKey', 'apiSecret'],                           optional: [] },
    bandwidth:       { required: ['apiKey', 'apiSecret', 'accountSid'],             optional: [] },
    plivo:           { required: ['apiKey', 'apiSecret'],                           optional: [] },
    bulkvs:          { required: ['apiKey'],                                        optional: ['apiEndpoint'] },
    skyetel:         { required: ['apiKey'],                                        optional: [] },
    flowroute:       { required: ['apiKey', 'apiSecret'],                           optional: [] },
    voipms:          { required: ['apiKey'],                                        optional: [] },
    didww:           { required: ['apiKey'],                                        optional: ['apiEndpoint'] },
    commio:          { required: ['apiKey', 'apiSecret'],                           optional: [] },
    voxtelesys:      { required: ['apiKey'],                                        optional: [] },
    questblue:       { required: ['apiKey'],                                        optional: [] },
    wavix:           { required: ['apiKey'],                                        optional: [] },
    voipinnovations: { required: ['apiKey'],                                        optional: [] },
    wayinteractive:  { required: ['apiKey'],                                        optional: [] },
    custom:          { required: ['apiKey'],                                        optional: ['apiSecret', 'apiEndpoint', 'accountSid'] },
};
